import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { INoahDeviceInventoryItemMapDetail, INoahDeviceInventoryItemMapsQueryParams, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<INoahDeviceInventoryItemMapDetail>, INoahDeviceInventoryItemMapsQueryParams>>(
	undefined as any
);
